import React from 'react';
import { Controller } from 'react-hook-form';
import { ErrorMessage } from '@hookform/error-message';
import CurrencyUsMask from 'components/Inputs/CurrencyUsMask';
import CurrencyMask from 'components/Inputs/CurrencyMask';

import { Row, Col, Input } from 'reactstrap';
import FlexSelect from 'components/Inputs/FlexSelect';
import { verifyRoles } from 'components/Authentication/VerifyRoles';

export const WhatsappForm = ({ canal, control, setValue, errors }) => {
  const errorFormMessage = (message) => (
    <p style={{ color: 'red' }}>{message}</p>
  );
  return (
    <>
      <Row className="mt-2">
        <Col md="6">
          <label className="form-control-label">Nome do canal</label>
          <Controller
            as={Input}
            control={control}
            name="nome_canal"
            defaultValue={canal?.nome_canal ?? ''}
            rules={{
              required: 'nome é um campo obrigatório'
            }}
          />
          <ErrorMessage
            errors={errors}
            name="nome_canal"
            render={({ message }) => errorFormMessage(message)}
          />
        </Col>
        <Col md="6">
          <label className="form-control-label">Descrição</label>
          <Controller
            as={Input}
            control={control}
            name="descricao"
            rules={{
              required: 'descrição é um campo obrigatório'
            }}
            defaultValue={canal?.descricao ?? ''}
          />
          <ErrorMessage
            errors={errors}
            name="descricao"
            render={({ message }) => errorFormMessage(message)}
          />
        </Col>
      </Row>
      <Row className="mt-2">
        <Col md="4">
          <label className="form-control-label">API Key</label>
          <Controller
            as={Input}
            control={control}
            name="apikey"
            rules={{
              required: 'API KEY é um campo obrigatório'
            }}
            defaultValue={canal?.apikey ?? ''}
          />
          <ErrorMessage
            errors={errors}
            name="apikey"
            render={({ message }) => errorFormMessage(message)}
          />
        </Col>
        <Col md="4">
          <label className="form-control-label">
            ID do Aplicativo* (AppId)
          </label>
          <Controller
            as={Input}
            control={control}
            name="appId"
            rules={{
              required: 'ID do aplicativo é um campo obrigatório'
            }}
            defaultValue={canal?.appId ?? ''}
          />
          <ErrorMessage
            errors={errors}
            name="appId"
            render={({ message }) => errorFormMessage(message)}
          />
        </Col>
        <Col md="4">
          <label className="form-control-label">Source</label>
          <Controller
            as={Input}
            control={control}
            defaultValue={canal?.source ?? ''}
            name="source"
            rules={{
              required: 'source é um campo obrigatório',
              validate: (value) => {
                if (!value) return true;
                let phoneFormated = value.replace(/\D/g, '');
                phoneFormated = phoneFormated.replace(/^0/, '');

                if (phoneFormated.length < 10 && phoneFormated.length > 0) {
                  return 'Telefone inválido';
                }
                return true;
              }
            }}
          />
          <ErrorMessage
            errors={errors}
            name="source"
            render={({ message }) => errorFormMessage(message)}
          />
        </Col>
      </Row>
      <Row className="mt-2">
        <Col md="6">
          <label className="form-control-label">Source Name</label>
          <Controller
            as={Input}
            control={control}
            name="srcName"
            rules={{
              required: 'Source Name é um campo obrigatório'
            }}
            defaultValue={canal?.srcName ?? ''}
          />
          <ErrorMessage
            errors={errors}
            name="srcName"
            render={({ message }) => errorFormMessage(message)}
          />
        </Col>
        <Col md="3">
          <label className="form-control-label">Custo por conversa (US$)</label>
          <Controller
            render={(props) => (
              <CurrencyUsMask
                valueController={setValue}
                value={props.value}
                fieldName="custoPorConversa"
                placeholder="Valor"
              />
            )}
            control={control}
            name="custoPorConversa"
            rules={{
              required: 'Custo por conversa é um campo obrigatório'
            }}
            defaultValue={canal?.custoPorConversa ?? ''}
          />
          <ErrorMessage
            errors={errors}
            name="custoPorConversa"
            render={({ message }) => errorFormMessage(message)}
          />
        </Col>
        <Col md="3">
          <label className="form-control-label">Cotação do dólar</label>
          <Controller
            render={(props) => (
              <CurrencyMask
                valueController={setValue}
                value={props.value}
                fieldName="cotacaoDolar"
                placeholder="Valor"
              />
            )}
            control={control}
            name="cotacaoDolar"
            rules={{
              required: 'Cotação do dólar é um campo obrigatório'
            }}
            defaultValue={canal?.cotacaoDolar ?? ''}
          />
          <ErrorMessage
            errors={errors}
            name="cotacaoDolar"
            render={({ message }) => errorFormMessage(message)}
          />
        </Col>
      </Row>
      <Row className="mt-2">
        <Col md="6">
          <label className="form-control-label">
            Armazenamento de mídias recebidas
          </label>
          <Controller
            render={(props) => (
              // O armazenamento padrão foi alterado para local conforme a task https://app.clickup.com/t/86adgnvqh
              <FlexSelect
                isClearable={true}
                dataOptions={[
                  {
                    label: 'Local (Padrão)',
                    value: 'LOCAL',
                    optionSubtitle:
                      'As mídias recebidas são armazenadas diretamente no servidor, garantindo preservação dos arquivos. No entanto, pode ser necessário expandir o espaço de armazenamento para evitar sobrecarga.'
                  },
                  {
                    label: 'Gupshup',
                    value: 'GUPSHUP',
                    optionSubtitle:
                      'As mídias recebidas são armazenadas temporariamente nos servidores da Gupshup e são automaticamente excluídas após 7 dias, sem possibilidade de recuperação. Ideal para quem deseja economia de armazenamento sem necessidade de retenção prolongada.'
                  }
                ]}
                isMulti={false}
                closeMenuOnSelect={true}
                value={props.value}
                isDisabled={
                  !verifyRoles(['CHANGE_WHATSAPP_MEDIA_STORAGE_CONFIG'])
                }
                valueController={(fieldName, value) => {
                  setValue(fieldName, value);
                }}
                fieldName="armazenamentoDeMidias"
                labelName="label"
                valueName="value"
              />
            )}
            control={control}
            name="armazenamentoDeMidias"
            rules={{ required: 'Campo obrigatório!' }}
            defaultValue={canal?.armazenamentoDeMidias ?? 'LOCAL'}
          />

          <ErrorMessage
            errors={errors}
            name="action"
            render={({ message }) => errorFormMessage(message)}
          />
        </Col>
      </Row>
    </>
  );
};
